import { ElementNode } from 'lexical';

export class CollapsibleContentNode extends ElementNode {
  static getType() {
    return 'collapsible-content';
  }

  static clone(node) {
    return new CollapsibleContentNode(node.__key);
  }

  createDOM() {
    const dom = document.createElement('div');
    dom.classList.add('Collapsible__content');
    return dom;
  }

  updateDOM() {
    return false;
  }

  static importDOM() {
    return {
      div: (domNode) => {
        if (!domNode.classList.contains('Collapsible__content')) {
          return null;
        }
        return {
          conversion: () => ({ node: $createCollapsibleContentNode() }),
          priority: 1,
        };
      },
    };
  }

  static importJSON() {
    return $createCollapsibleContentNode();
  }

  isShadowRoot() {
    return true;
  }

  exportDOM() {
    const element = document.createElement('div');
    element.classList.add('Collapsible__content');
    return { element };
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'collapsible-content',
      version: 1,
    };
  }
}

export function $createCollapsibleContentNode() {
  return new CollapsibleContentNode();
}

export function $isCollapsibleContentNode(node) {
  return node instanceof CollapsibleContentNode;
}
